// * Bootstrap libraries
import "./_bootstrap";


(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.mobileNavs = {
    attach: function (context, settings) {
      $(once('event-bindings', 'body', context)).each(function () {

        // Add mobileBreakpoint class to body so contained keyboard focus on menu only triggers when mobile menu is present
        var handleMatchMedia = function (mediaQuery) {
          if (mediaQuery.matches) {
            $("body").addClass("mobileBreakpoint");
          } else {
            $("body").removeClass("mobileBreakpoint");
          }
        },

          mql = window.matchMedia('all and (max-width: 999px)');

        handleMatchMedia(mql);
        mql.addListener(handleMatchMedia);

        var searchToggle = $('#searchToggle');
        var searchBar = $('#searchBar');

        $(searchToggle).click(function () {
          $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false' ? 'true' : 'false');
          $(searchBar).attr('aria-hidden', $(searchBar).attr('aria-hidden') === 'false' ? 'true' : 'false').toggleClass('opened');
          $('#sidebarToggle').attr('aria-expanded', 'false');
          $('#sidebarTOC').removeClass('show');
          $('#section-menu').removeClass('show');
        });



        if ($('body').hasClass('mobileBreakpoint')) {
          var secondaryMenu = $('.nav-container .block-menu-blockutility-menu');
          $('.navbar-collapse').prepend(secondaryMenu);
        } else {
          $(secondaryMenu).insertAfter('.search-block-form-toggle');
        }

        window.addEventListener("resize", function () {
          var secondaryMenu = $('.nav-container .block-menu-blockutility-menu');

          if (window.innerWidth > 1001) {
            $(secondaryMenu).insertAfter('.search-block-form-toggle');
          }

          if (window.innerWidth < 1000) {
            $('.navbar-collapse').prepend(secondaryMenu);
          }

        });

        /*
                // Select all .nav-item a elements
                var navItems = document.querySelectorAll('.block-menu-blockutility-menu .nav-item a');
        
                // Check if there are at least two .nav-item a elements
                if (navItems.length >= 2) {
                  // Target the second .nav-item a element
                  var secondNavItem = navItems[1];
        
                  // Modify its target attribute to open in a new window/tab
                  secondNavItem.target = '_blank';
                } */

        function closeAllMobileNavs() {
          $('.mobileBreakpoint .navbar .navbar-collapse').removeClass('show');
          $('.mobileBreakpoint .navbar-toggler').attr('aria-expanded', 'false');
          $(searchToggle).attr('aria-expanded', 'false');
          $(searchBar).attr('aria-hidden', 'true').removeClass('opened');
          $('#sidebarToggle').attr('aria-expanded', 'false');
          $('#sidebarTOC').removeClass('show');
          $('#section-menu').removeClass('show');

        }


        $('body').on('keydown', function (e) {
          if (e.keyCode == 27) { // escape key maps to keycode `27`
            closeAllMobileNavs();
          }
        });

  


        if ($('body').hasClass('node-type--guide')) {
          // Select the sticky element
          const stickyElement = document.getElementById('sidebar');

          // Define a function that will be called when the sticky state changes
          function handleStickyChange(entries) {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                $('.node-type--guide #sidebar').addClass('sticky-border');
              } else {
                $('.node-type--guide #sidebar').removeClass('sticky-border');
              }
            });
          }

          // Create the observer with the function and options
          const observer = new IntersectionObserver(handleStickyChange, {
            root: null, // observing for viewport
            threshold: [1], // adjust this value based on your needs
            rootMargin: '0px 0px 0px 0px' // tweak this margin based on the sticky offset
          });

          // Start observing the sticky element
          observer.observe(stickyElement);
        }


      });
    }
  }

  Drupal.behaviors.extLinks = { attach: function (context, settings) { $(once('extLinks', 'body', context)).each(function () { $('a').filter(function () { return this.hostname && this.hostname !== location.hostname; }).addClass('external').append("<span class='visually-hidden'>(link is external)</span>"); }); } };

  Drupal.behaviors.searchFocus = {
    attach: function (context, settings) {
      $(once('search-focus-event-bindings', 'body', context)).each(function () {
        var searchToggle = document.getElementById('searchToggle');
        var searchForm = document.getElementById('search-block-form');
        var searchInput = document.getElementById('edit-keys');

        function focusSearchInput() {

          setTimeout(function () {
            $(searchInput).focus();
          }, 300);
        }

        if (searchToggle) {
          searchToggle.addEventListener('click', focusSearchInput);
          searchToggle.addEventListener('keypress', (event) => {
            if (event.key === 'Enter') {
              focusSearchInput();
            }
          });
        }


      });
    }
  };
      
  Drupal.behaviors.sidebarMove = {
    attach: function (context, settings) {
        $(once('sidebar-move', 'body', context)).each(function () {
            const sidebar = document.querySelector('#sidebar');
            const sidebarRegion = document.querySelector('.desktop-sidebar');
            const mainRegion = document.querySelector('.mobile-sidebar');

            if (sidebar && sidebarRegion && mainRegion) {
                function adjustSidebarPosition() {
                    if (window.innerWidth <= 999) {
                        if (!mainRegion.contains(sidebar)) {
                            mainRegion.insertBefore(sidebar, mainRegion.firstChild);
                            console.log('Moved sidebar to mobile-sidebar');
                        }
                    } else {
                        if (!sidebarRegion.contains(sidebar)) {
                            sidebarRegion.insertBefore(sidebar, sidebarRegion.firstChild);
                            console.log('Moved sidebar to desktop-sidebar');
                        }
                    }
                }

                // Call function initially and on window resize
                adjustSidebarPosition();
                $(window).off('resize.sidebarMove').on('resize.sidebarMove', adjustSidebarPosition);
            }
        });
    }
};


  Drupal.behaviors.decisionTree = {
    attach: function (context, settings) {
      $(once('decision-tree', 'body', context)).each(function () {
        // Monitor for style changes to detect display: block for .decision-tree-options or .decision-tree-options-end
        function notifyOnElementDisplayBlock() {
          // Select elements with either .decision-tree-options or .decision-tree-options-end class
          const elements = $('.decision-tree-options, .decision-tree-options-end', context);
  
          // Function to check, append notification, and scroll to the element
          const checkAndNotify = () => {
            elements.each(function () {
              // Only append if the element is displayed and hasn't been marked as shown
              if ($(this).css('display') === 'block' && !$(this).data('displayed')) {
                $('#decision-tree-notification').append('New section loaded<br>');
                $(this).data('displayed', true); // Mark this element as displayed
  
                // Scroll to the element smoothly using jQuery's get method to ensure a native DOM element
                $(this).get(0).scrollIntoView({ behavior: 'smooth' });
              }
            });
          };
  
          // MutationObserver to detect changes in element styles
          const observer = new MutationObserver(checkAndNotify);
  
          // Observe style changes for each element
          elements.each(function () {
            observer.observe(this, { attributes: true, attributeFilter: ['style'] });
          });
        }
  
        // Call the function to start observing
        notifyOnElementDisplayBlock();
      });
    }
  };

  Drupal.behaviors.ariaAccordions = {
    attach: function (context, settings) {
      $(once('aria-accordions', 'body', context)).each(function () {
        // Monitor for style changes to detect display: block for .decision-tree-options or .decision-tree-options-end
        function notifyOnElementDisplayBlock() {
          // Select elements with either .decision-tree-options or .decision-tree-options-end class
          const elements = $('.decision-tree-options, .decision-tree-options-end', context);
  
          // Function to check, append notification, and scroll to the element
          const checkAndNotify = () => {
            elements.each(function () {
              // Only append if the element is displayed and hasn't been marked as shown
              if ($(this).css('display') === 'block' && !$(this).data('displayed')) {
                $('#decision-tree-notification').append('New section loaded<br>');
                $(this).data('displayed', true); // Mark this element as displayed
  
                // Scroll to the element smoothly using jQuery's get method to ensure a native DOM element
                $(this).get(0).scrollIntoView({ behavior: 'smooth' });
              }
            });
          };
  
          // MutationObserver to detect changes in element styles
          const observer = new MutationObserver(checkAndNotify);
  
          // Observe style changes for each element
          elements.each(function () {
            observer.observe(this, { attributes: true, attributeFilter: ['style'] });
          });
        }
  
        // Call the function to start observing
        notifyOnElementDisplayBlock();
      });
    }
  };
  
  




  // recaptcha a11y fix
  var intervalID = window.setInterval(myCallback, 50);
  function myCallback() {
    var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
    if (textAreaCheck.length > 0) {
      $(textAreaCheck).attr('aria-labelledby', 'g-recaptcha-response');
      console.log($(textAreaCheck));
      clearInterval(intervalID);
    }
  }

  $('#edit-get-help ~ .form-actions input').val('Next page');

})(jQuery, Drupal);

